<template>
  <div class="invite-container d-none d-md-block tw-text-text">
    <div
      class="invite tw-border tw-border-border tw-bg-background"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div class="invite-header">
        <IconButton
          @click="close"
          aria-label="Close"
          :icon="{
            default: { icon: 'fa-regular fa-xmark', class: 'tw-text-[12px]' },
            hover: { icon: 'fa-solid fa-xmark', class: 'tw-text-[12px]' },
          }"
          class="close"
        />

        <div class="d-flex">
          <div class="invite-message">
            <h3>Can we help?</h3>
            <div>Agents are available to answer any questions</div>
            <Btn
              class="mt-3"
              variant="secondary"
              size="small"
              @click="chat"
              :loading="loading"
              :disabled="loading"
            >
              Chat with us
            </Btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Btn from "@/components/display/Btn";
import { chatInviteSetup } from "@/utils/chatSetup";
import IconButton from "@/components/display/IconButton.vue";

export default {
  name: "ChatInvite",
  emits: ["close"],
  components: {
    IconButton,
    Btn,
  },
  setup: chatInviteSetup,
};
</script>

<style lang="scss" scoped>
.invite-container {
  position: fixed;
  height: 0;
  overflow: visible;
  bottom: 12.5rem;
  right: 2rem;
  width: 214px;
  z-index: 1060;
}
.invite {
  opacity: 1;
  position: relative;
  flex-basis: 350px;
  max-width: 350px;
  font-size: 0.875rem;
  background-clip: padding-box;

  .invite-header {
    padding: 0.875rem 0.875rem;
    position: relative;
    z-index: 100;
  }
  .invite-message {
    margin-left: 1rem;
    padding-right: 1rem;
  }
  .close {
    position: absolute;
    right: 14px;
    top: 14px;
  }
  .icon.size-20 {
    width: auto;
  }
}
</style>
